import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AddressFormModel } from '@base/models/form/address-form.model';
import { Country } from '@base/backend';

export function createAddressForm(): FormGroup<AddressFormModel> {
  return new FormGroup<AddressFormModel>({
    houseNumber: new FormControl<string | null>(null, [Validators.required]),
    street: new FormControl<string | null>(null, [Validators.required]),
    city: new FormControl<string | null>(null, [Validators.required]),
    zip: new FormControl<string | null>(null, [Validators.required]),
    country: new FormControl<Country | null>(Country.Austria, [Validators.required])
  });
}

